// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Header_wrapper__3tGRg","logo":"Header_logo__3T0lc"};